import React from "react";
import ReactDOM from "react-dom";
import { ConfigProvider } from "antd";
import { Provider } from "react-redux";
import "moment/locale/zh-cn";
import locale from "antd/es/locale/zh_CN";
import { createStore } from "../redux";
import { initOptions } from "../core/options";

import App from "./app";
import ErrorBoundary from "../components/ErrorBoundary";

export function init(options, element) {
  initOptions(options);
  return ReactDOM.render(
    <ConfigProvider locale={locale}>
      <Provider store={createStore()}>
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </Provider>
    </ConfigProvider>,
    element
  );
}
